// eslint-disable-next-line
import React from "react";



const ThirdPartyLink = ({ to = "", children }) => {

  return (
    <>
      <a href={`${to}`} target="_blank" rel="noopener noreferrer">
        {children}
      </a >
    </>
  )
}

export default ThirdPartyLink